import { z } from 'zod';
import { PRODUCT_CATEGORY_SCHEMA } from '../order-product/product-category.ts';

export const SyncOrgPaymentTermRequestSchema = z.object({
    productId: z.string(),
    productCategory: PRODUCT_CATEGORY_SCHEMA.optional(),
    customerOrganizationId: z.number().optional(),
    organizationIds: z.array(z.number()),
});
